import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=dc9cbec2&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=ts&"
export * from "./BasicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=dc9cbec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9cbec2",
  null
  
)

export default component.exports